<template>
  <lwf-autocomplete
    :value="value"
    label="Types de mains courantes"
    :options="options"
    v-bind="vAttrs"
    v-on="$listeners"
  >
    <template #option="scope">
      <q-item
        v-ripple
        :disable="scope.opt.root"
        v-bind="scope.itemProps"
        v-on="scope.itemEvents"
      >
        <q-item-section
          v-if="!scope.opt.root"
          avatar
        >
          <q-icon :name="scope.opt.icon || 'fa fa-caret-right'" />
        </q-item-section>
        <q-item-section>
          <q-item-label>
            {{ scope.opt.name }}
          </q-item-label>
          <q-item-label caption>
            {{ scope.opt.caption }}
          </q-item-label>
        </q-item-section>
      </q-item>
    </template>
  </lwf-autocomplete>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import LwfAutocomplete from 'components/core/LwfAutocomplete'
import validateProxyMixin from '@/mixins/validateProxyMixin'

export default {
  name: 'AutocompleteTypeMc',
  components: { LwfAutocomplete },
  mixins: [validateProxyMixin],
  props: {
    value: {
      type: [String, Object, Array],
      default: undefined
    },
    notRestricted: Boolean
  },
  computed: {
    ...mapState({
      CONSTS: 'CONSTS'
    }),
    ...mapGetters({
      constServiceEventTypesKeys: 'constServiceEventTypesKeys',
      isRestrictedEventType: 'isRestrictedEventType'
    }),
    vAttrs () {
      return {
        optionValue: 'id',
        ...this.$attrs
      }
    },
    options () {
      const { notRestricted } = this
      const options = []
      this.CONSTS.serviceEventTypes.forEach((eType) => {
        if (notRestricted && this.isRestrictedEventType(eType.typeKey)) {
          return
        }
        const t = this.constServiceEventTypesKeys[eType.typeKey]
        if (t.enabled) {
          options.push(t)
          t.subTypes.forEach((subType) => {
            if (subType.enabled) {
              options.push({
                icon: t.icon,
                ...subType
              })
            }
          })
        }
      })
      return options
    }
  }
}
</script>

<style scoped>

</style>
